import { render } from "./TextOverflow.vue?vue&type=template&id=6656152a&scoped=true"
import script from "./TextOverflow.vue?vue&type=script&setup=true&lang=js"
export * from "./TextOverflow.vue?vue&type=script&setup=true&lang=js"

import "./TextOverflow.vue?vue&type=style&index=0&id=6656152a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6656152a"],['__file',"src/components/ui/TextOverflow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6656152a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6656152a', __exports__)) {
    console.log('reload')
    api.reload('6656152a', __exports__)
  }
  
  module.hot.accept("./TextOverflow.vue?vue&type=template&id=6656152a&scoped=true", () => {
    console.log('re-render')
    api.rerender('6656152a', render)
  })

}


export default __exports__